<template>
  <BrandIcon
    v-if="isBrandIcon"
    :name="name"
    :size="size"
    :stroke-width="strokeWidth"
    v-bind="$attrs"
  />
  <component
    :is="iconMap[name]"
    v-else-if="iconMap[name]"
    :size="size"
    :stroke-width="strokeWidth"
    v-bind="$attrs"
  />
</template>

<script>
import BrandIcon, { BRAND_ICONS } from './BrandIcon.vue'
import {
  Home,
  User,
  FileText,
  Briefcase,
  Mail,
  Menu,
  X,
  Sun,
  Moon,
  ChevronRight,
  LayoutGrid,
  Plus,
  Globe,
  Download,
  GitBranch,
  ExternalLink,
  Search,
  LogOut,
  Settings,
  ArrowLeft,
  Send,
  MapPin,
  Phone,
  Code2,
  GraduationCap,
  Heart,
  Lock,
  Clock,
  CheckCircle,
  AlertCircle,
  Pencil,
  Trash2,
  Eye,
  Upload,
  FileArchive,
  Smartphone,
  BarChart3,
  RefreshCw,
} from '@lucide/vue'

const iconMap = {
  Home,
  User,
  FileText,
  Briefcase,
  Mail,
  Menu,
  X,
  Sun,
  Moon,
  ChevronRight,
  LayoutGrid,
  Plus,
  Globe,
  Download,
  GitBranch,
  ExternalLink,
  Search,
  LogOut,
  Settings,
  ArrowLeft,
  Send,
  MapPin,
  Phone,
  Code2,
  GraduationCap,
  Heart,
  Lock,
  Clock,
  CheckCircle,
  AlertCircle,
  Pencil,
  Trash2,
  Eye,
  Upload,
  FileArchive,
  Smartphone,
  BarChart3,
  RefreshCw,
}

export default {
  name: 'AppIcon',
  components: { BrandIcon },
  props: {
    name: { type: String, required: true },
    size: { type: Number, default: 20 },
    strokeWidth: { type: Number, default: 1.75 },
  },
  computed: {
    isBrandIcon() {
      return BRAND_ICONS.includes(this.name)
    },
  },
  setup() {
    return { iconMap }
  },
}
</script>
